<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" backdrop shadow :visible="!!equipmentID" :right="true"
            no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }" v-if="currentEquipment">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center w-100 mr-2">
                        <div class="text-nowrap">
                            {{ currentEquipment.unit_no }}
                        </div>
                        <!-- <b-button
                            class="ml-5 export pe-none d-flex justify-content-center align-items-center w-100px h-40px"
                            :class="currentEquipment.status === 'Active'
                                ? 'equipment'
                                : currentEquipment.status === 'Assigned'
                                    ? 'assigned-equipment'
                                    : 'inactive-equipment'
                                "
                            :variant="currentEquipment.status === 'Active' ? 'primary' : currentEquipment.status === 'Assigned' ? 'success' : 'secondary'">
                            <p class="mb-0">{{ currentEquipment.status }}</p>
                        </b-button> -->
                    </div>
                    <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 mt-0" v-if="allowUpdateEquipment">
                        <template slot="button-content">
                            <b-icon class="dots" icon="three-dots"></b-icon>
                        </template>
                        <!-- <b-dropdown-item-button class="mb-2"
                            @click="generateEquipmentQRCode(currentEquipment.unit_no, currentEquipment.unit_no + '-qrcode', qrCodeUrl)"
                            v-if="qrCodeUrl && currentEquipment.status !== 'Inactive'">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.qrCode') }}</p>
                        </b-dropdown-item-button> -->
                        <b-dropdown-item-button class="mb-2"
                            v-if="currentEquipment.status === 'Assigned' || currentEquipment.status === 'Active'"
                            @click="showEquipmentModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.deactivate') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button class="mb-2" v-else @click="showEquipmentModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.activate') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="allowDeleteEquipment" @click="showDeleteEquipmetModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.deleteType', { type: currentEquipment.type }) }}</p>
                        </b-dropdown-item-button>
                    </b-dropdown>
                </div>
            </template>
            <div class="body" v-if="currentEquipment">
                <div class="sidebar-tabs">
                    <div class="bg-white rounded">
                        <v-tabs class="team-tabs mb-0" v-model="activeTab" show-arrows>
                            <v-tab key='info'>{{ $t('editEquipment.infoTab') }}</v-tab>
                            <v-tab key='documents' v-if="allowViewDocEquipment">{{ $t('editEquipment.documentsTab') }}</v-tab>
                            <v-tab key='notes'>{{ $t('editEquipment.notesTab') }}</v-tab>
                            <v-tab key='activity' v-if="showActivitySection">{{ $t('editEquipment.activityTab') }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key='info'>
                        <hr class="mt-0" />
                        <div class="d-block text-center mt-4rem">
                            <b-row class="px-4">
                                 <div v-if="requiredDocsRecords.length" class="px-3 w-100">
                                 <b-alert show variant="danger" class="f-14 text-left w-100">{{ requiredDocsMessage }}</b-alert>
                                 </div>
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('equipmentForm.basic') }}</h3>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.unitLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentEquipment.unit_no" type="text"
                                            :placeholder="$t('equipmentForm.unitPlaceholder')" class="unit" :disabled="!allowUpdateEquipment"
                                            required></b-form-input>
                                        <p v-if="errors && errors.unit_no" class="field-error mb-lg-3">
                                            {{ errors.unit_no[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('editEquipment.driverLabel') }}</label>
                                    <v-select class="f-12" :disabled="!allowUpdateEquipment" :options="drivers"
                                        v-model="equipmentDriver" :reduce="(option) => option.id" @search="searchDriver"
                                        @input="getDriverData">
                                        <span slot="no-options">
                                            {{ $t('editEquipment.searchName') }}
                                        </span>
                                    </v-select>
                                    <a v-if="equipmentDriver" class="text-primary mt-3 f-14 cursor-pointer"
                                        @click="goToDriverDetail(equipmentDriver, getDriverLabel())"><u>{{ $t('editEquipment.goToDriver', { label: getDriverLabel() }) }}</u></a>
                                </b-col>
                                <b-col sm="12" class="text-left select_arrow mt-3">
                                    <label>{{ $t('equipmentForm.subtypeLabel') }}</label>
                                    <b-form-input type="text" v-model="currentEquipment.subtype"
                                        :disabled="!allowUpdateEquipment" :placeholder="$t('equipmentForm.subtypePlaceholder')"
                                        class="unit"></b-form-input>
                                    <p v-if="errors && errors.subtype" class="field-error mb-lg-3">
                                        {{ errors.subtype[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <b-form-group :label="$t('editEquipment.statusLabel')" class="text-left mb-0">
                                        <b-form-input type="text" :value="currentEquipment.status"
                                            :placeholder="$t('editEquipment.statusPlaceholder')" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="px-4">
                                <b-col sm="12" class="text-left mt-3">
                                    <b-form-group :label="$t('equipmentForm.vinLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.vin_no"
                                            :placeholder="$t('equipmentForm.vinPlaceholder')" :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.yearLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.year" :placeholder="$t('equipmentForm.yearPlaceholder')"
                                            :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.makeLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.make" :placeholder="$t('equipmentForm.makePlaceholder')"
                                            :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.modelLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.model" :placeholder="$t('equipmentForm.modelPlaceholder')"
                                            :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.plateLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.plate_no"
                                            :placeholder="$t('equipmentForm.platePlaceholder')" :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3" v-if="currentEquipment.state">
                                    <label class="state">{{ $t('equipmentForm.stateLabel') }}</label>
                                    <v-select class="f-12 h-40px" :options="states" :reduce="(option) => option.id"
                                        v-model="currentEquipment.state.id" :disabled="!allowUpdateEquipment" />
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('equipmentForm.tagsSection') }}</h3>
                                <b-col md="12" class="mt-3">
                                    <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                        v-model="existingTags" :disabled="!allowUpdateEquipment" />
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('equipmentForm.divisionSection') }}</h3>
                                <b-col sm="12" class="mt-3">
                                    <v-select class="f-12" :clearable="false" :options="allDivisions"
                                        v-model="currentEquipment.division" :reduce="(option) => option.id" />
                                </b-col>
                                <p v-if="errors && errors.division" class="field-error px-3">
                                    {{ errors.division[0] }}
                                </p>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4"
                                :class="{ 'mb-7rem': !equipmentCustomFields.length }">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('equipmentForm.detailsSection') }}</h3>
                                <!-- <b-col sm="12" class="mt-3">
                                    <b-form-group label="Length:" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.length"
                                            placeholder="Enter Length:"
                                            :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                                $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group label="Weight:" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.weight"
                                            placeholder="Enter Weight:"
                                            :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                                $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group label="Number of Axles:" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.number_of_axles"
                                            placeholder="Enter Axles:"
                                            :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                                $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group label="Color:" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.color"
                                            placeholder="Enter Color:"
                                            :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                                $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"></b-form-input>
                                    </b-form-group>
                                </b-col> -->
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.odometerLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-mask="numberMask" :placeholder="$t('equipmentForm.odometerPlaceholder')"
                                            v-model="currentEquipment.current_odometer"
                                            :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.valueLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.value" :placeholder="$t('equipmentForm.valuePlaceholder')"
                                            :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('equipmentForm.serialLabel')" class="text-left mb-0">
                                        <b-form-input type="text" v-model="currentEquipment.serial_number"
                                            :placeholder="$t('equipmentForm.serialPlaceholder')" :disabled="!allowUpdateEquipment"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <!-- <b-col sm="12" class="text-left select_arrow mt-3">
                                    <label>Fuel Type:</label>
                                    <b-form-select class="f-12"
                                        :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                            $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"
                                        :options="[
                                            {
                                                value: null,
                                                text: '',
                                            },
                                            {
                                                value: 'Diesel',
                                                text: 'Diesel',
                                            },
                                            {
                                                value: 'Bio-Diesel',
                                                text: 'Bio-Diesel',
                                            },
                                            {
                                                value: 'Gasoline',
                                                text: 'Gasoline',
                                            },
                                            {
                                                value: 'Ethanol',
                                                text: 'Ethanol',
                                            },
                                        ]" v-model="currentEquipment.fuel_type"></b-form-select>
                                    <p v-if="errors && errors.fuel_type" class="field-error mb-lg-3">
                                        {{ errors.fuel_type[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="text-left select_arrow mt-3">
                                    <label>Ownership:</label>
                                    <b-form-select class="f-12"
                                        :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                            $store.state.user.user.team_member.role !== 'Operations' && $store.state.user.user.team_member.role !== 'Maintenance Manager'"
                                        :options="[
                                            {
                                                value: null,
                                                text: '',
                                            },
                                            {
                                                value: 'Owned',
                                                text: 'Owned',
                                            },
                                            {
                                                value: 'Leased',
                                                text: 'Leased',
                                            },
                                            {
                                                value: 'Owner Operator',
                                                text: 'Owner Operator',
                                            }
                                        ]" v-model="currentEquipment.ownership"></b-form-select>
                                    <p v-if="errors && errors.ownership" class="field-error mb-lg-3">
                                        {{ errors.ownership[0] }}
                                    </p>
                                </b-col> -->
                                <b-col sm="12" class="text-left mt-3">
                                    <label for="active-datepicker" class="state">{{ $t('equipmentForm.activeDateLabel') }}</label>
                                    <date-picker v-model="currentEquipment.active_date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="currentEquipment.active_date = ''"
                                        :placeholder="$t('equipmentForm.selectDate')" class="date-picker-custom" :teleport="'body'"
                                        :disabled="!allowUpdateDocEquipment"></date-picker>
                                    <p v-if="errors && errors.active_date" class="field-error">
                                        {{ errors.active_date[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="text-left my-3">
                                    <label for="active-datepicker" class="state">{{ $t('equipmentForm.inactiveDateLabel') }}</label>
                                    <date-picker v-model="currentEquipment.inactivate_date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="currentEquipment.inactivate_date = ''"
                                        :placeholder="$t('equipmentForm.selectDate')" class="date-picker-custom" :teleport="'body'"
                                        :disabled="!allowUpdateDocEquipment"></date-picker>
                                    <p v-if="errors && errors.inactivate_date" class="field-error">
                                        {{ errors.active_date[0] }}
                                    </p>
                                </b-col>
                            </b-row>
                            <template v-if="equipmentCustomFields.length">
                                <hr class="m-4" />
                                <b-row class="px-4 mb-7rem">
                                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('equipmentForm.customFieldsSection') }}</h3>
                                    <b-col v-for="field in equipmentCustomFields" :key="field.id" sm="12" class="mt-3">
                                        <b-form-group v-if="field.field_type === 'text'" :label="`${field.name}:`"
                                            class="text-left mb-0">
                                            <b-form-input v-model="customFieldValues[field.id]" type="text"
                                                :placeholder="`Enter ${field.name}`" class="unit"
                                                :disabled="!allowUpdateEquipment"></b-form-input>
                                        </b-form-group>
                                        <b-form-group v-else-if="field.field_type === 'number'"
                                            :label="`${field.name}:`" class="text-left mb-0">
                                            <b-form-input v-model="customFieldValues[field.id]" type="number"
                                                :placeholder="`Enter ${field.name}`" class="unit"
                                                :disabled="!allowUpdateEquipment"></b-form-input>
                                        </b-form-group>
                                        <b-form-group v-else-if="field.field_type === 'date'"
                                            :label="`${field.name}:`" class="text-left mb-0">
                                            <b-form-input v-model="customFieldValues[field.id]" type="date"
                                                :placeholder="`Enter ${field.name}`" class="unit"
                                                :disabled="!allowUpdateEquipment"></b-form-input>
                                        </b-form-group>
                                        <div v-else-if="field.field_type === 'select'" class="text-left">
                                            <label class="state">{{ field.name }}:</label>
                                            <v-select class="f-12" :options="field.options"
                                                :disabled="!allowUpdateEquipment"
                                                v-model="customFieldValues[field.id]" />
                                        </div>
                                        <div v-else-if="field.field_type === 'multi_select'" class="text-left">
                                            <label class="state">{{ field.name }}:</label>
                                            <v-select class="f-12" :options="field.options" multiple
                                                :disabled="!allowUpdateEquipment"
                                                v-model="customFieldValues[field.id]" />
                                        </div>
                                    </b-col>
                                </b-row>
                            </template>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='documents' v-if="allowViewDocEquipment">
                        <div class="d-block body mb-7rem">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editEquipment.documentsHeading') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    v-if="allowCreateDocEquipment" @click="addDocument">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editEquipment.addDocument') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="items.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                    {{ $t('editEquipment.noDocuments') }}
                                </div>
                                <div v-for="section in docSections" :key="section.key" class="doc-section">
                                    <template v-if="section.title">
                                        <hr class="my-4" />
                                        <h3 class="f-18 font-weight-bold text-left mb-3">{{ section.title }}</h3>
                                    </template>
                                    <div class="document-cards-list">
                                        <div v-for="item in section.docs" :key="item.pk" class="document-card">
                                            <div class="document-card-top">
                                                <span class="document-card-title">
                                                    {{ item.Description && item.Description !== 'null' ? item.Description :
                                                        '-' }}
                                                </span>
                                                <span class="document-card-date" v-html="item.expiry_date">
                                                </span>
                                            </div>
                                            <div class="document-card-divider"></div>
                                            <div class="document-card-bottom">
                                                <div class="document-card-switches ml-2">
                                                    <b-form-checkbox :disabled="!allowUpdateDocEquipment" v-model="item.Driver"
                                                        name="check-button" switch size="lg"
                                                        @change="updateDocumentOnToggle(item.id, 'driver', item.Driver)">
                                                        <span class="document-card-label">{{ $t('editEquipment.docCardDriver') }}</span>
                                                    </b-form-checkbox>
                                                    <!-- <b-form-checkbox :disabled="!allowUpdateDocEquipment"
                                                        v-model="item.dot_mode" name="check-button" switch size="lg"
                                                        @change="updateDocumentOnToggle(item.id, 'dot_mode', item.dot_mode)">
                                                        <span class="document-card-label">DOT Mode</span>
                                                    </b-form-checkbox> -->
                                                </div>
                                                <div class="document-card-actions">
                                                    <svg @click="editDocument(item.id, item.pk)" class="cursor-pointer"
                                                        width="20" height="15" viewBox="0 0 20 15" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg @click="downloadDoc(item.pk, item.name)" class="cursor-pointer"
                                                        width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg v-if="allowDeleteDocEquipment"
                                                        @click="showArchivePopup(item.pk, item.is_archived)"
                                                        class="cursor-pointer" width="20" height="17" viewBox="0 0 20 17"
                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M17.6154 4.40909L17.0385 14.0745C17.0074 14.5955 16.7753 15.0851 16.3897 15.443C16.0041 15.8009 15.4942 16.0002 14.9643 16H5.03569C4.50581 16.0002 3.99589 15.8009 3.6103 15.443C3.22471 15.0851 2.99262 14.5955 2.96154 14.0745L2.38462 4.40909M8.15385 7.81818H11.8462M2.03846 4.40909H17.9615C18.5348 4.40909 19 3.95091 19 3.38636V2.02273C19 1.45818 18.5348 1 17.9615 1H2.03846C1.46523 1 1 1.45818 1 2.02273V3.38636C1 3.95091 1.46523 4.40909 2.03846 4.40909Z"
                                                            stroke="#FF7900" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg @click="showPopup(item.pk)" class="cursor-pointer"
                                                        v-if="allowDeleteDocEquipment" width="19" height="20"
                                                        viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="notes">
                        <div class="mt-4rem">
                            <Notes :key="currentEquipment.id" :noteURL="'app/equipment/' + currentEquipment.id + '/note'"
                                :allowUpdate="allowUpdateEquipment" @updateNotes="$emit('updateData', true)" />
                        </div>
                    </v-tab-item>
                    <v-tab-item key="activity" v-if="showActivitySection">
                        <div class="mt-4rem mb-6rem">
                            <ActivityLogs :key="currentEquipment.id" :record="currentEquipment.unit_no"
                                :object_id="currentEquipment.id" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <div class="sidebar-footer position-fixed">
                    <div class="d-flex align-items-center justify-content-end" v-if="allowUpdateEquipment">
                        <div class="text-right modal-footer border-0 p-0">
                            <b-button class="mx-0 m-0 h-40px w-100px"
                                :class="hasChanged && allowUpdateEquipment && activeTab === 0 ? 'mr-3' : ''" @click="closePopup"
                                variant="secondary">{{ $t('editEquipment.close') }}</b-button>
                            <b-button class="mx-0 m-0 mb-0 h-40px w-100px" v-if="hasChanged && allowUpdateEquipment && activeTab === 0"
                                variant="primary" @click="updateEquipmentData">{{ $t('editEquipment.save') }}</b-button>
                        </div>
                    </div>
                    <div v-else class="text-right">
                        <b-button class="mx-0 m-0 h-40px w-100px" @click="closePopup" variant="secondary">{{ $t('editEquipment.close') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <AddTags v-if="showTagsModal" @confirmTags="addTag($event)" :existingTags="currentEquipment.tags"
            :type="'Equipment'" :equipmentID="equipmentID" />
        <qriously v-if="currentEquipment" class="d-none" :value="'https://app.digitalpermitbook.com/search-equipment?equipment=' +
            currentEquipment.id
            " :size="200" ref="qrcode" />
        <DeleteModal v-if="showEquipmentModal" @confirm="changeEquipmentStatusItem($event)"
            :message="currentEquipment.status === 'Assigned' || currentEquipment.status === 'Active' ? $t('editEquipment.deactivateConfirm') : $t('editEquipment.activateConfirm')"
            :removeMessage="currentEquipment.status === 'Assigned' || currentEquipment.status === 'Active' ? $t('editEquipment.deactivate') : ''"
            :successMessage="currentEquipment.status !== 'Assigned' && currentEquipment.status !== 'Active' ? $t('editEquipment.activate') : ''" />
        <DeleteModal :message="$t('editEquipment.deleteDocConfirm')" v-if="showDocumentModal"
            @confirm="deleteDocumentItem($event)" />
        <DeleteModal
            :message="`<h3 class='f-18 mb-3'>${$t('editEquipment.deleteEquipmentTitle', { type: currentEquipment.type.toLowerCase() })}</h3> <p class='text-grey f-14 fw-400 mb-0'>${$t('editEquipment.deleteEquipmentBody', { type: currentEquipment.type.toLowerCase() })}</p>`"
            v-if="showDeleteEquipmetModal" @confirm="deleteEquipmentItem($event)" />
        <DeleteModal
            :message="unarchiveDocument ? $t('editEquipment.unarchiveDocConfirm') : $t('editEquipment.archiveDocConfirm')"
            :updateMessage="true" :removeMessage="''" v-if="showArchiveDocumentModal"
            @confirm="archiveDocumentItem($event)" />
        <b-modal id="modal-document" centered :footer-class="'d-block border-0 pt-0 pb-3 m-0'" @shown="resetField"
            no-close-on-backdrop size="lg" :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('editEquipment.documentModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0" v-if="editDocumentFlag">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button
                        :class="(fileName && allowUpdateDocEquipment && editDocumentFlag) || allowDeleteDocDrivers ? 'mb-2' : ''"
                        @click="downloadDoc(documentData.id, `${currentEquipment.unit_no}-${documentData.description ? documentData.description : ''}`)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button v-if="(fileName && allowUpdateDocEquipment && editDocumentFlag)"
                        :class="allowDeleteDocEquipment ? 'mb-2' : ''" @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button class="mb-2"
                        @click="showArchivePopup(documentData.id, documentData.is_archived)"
                        v-if="allowDeleteDocEquipment">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ documentData.is_archived ?
                            $t('editEquipment.unarchive') : $t('editEquipment.archive') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showPopup(documentData.id)" v-if="allowDeleteDocEquipment">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown id="dropdown-preview" text="text" class="load-dropdown mt-0"
                    v-if="!editDocumentFlag && fileName">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editEquipment.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col lg="4" sm="12">
                        <div class="text-left mb-3">
                            <label for="modal-datepicker" class="state">{{ $t('editEquipment.dateLabel') }}</label>
                            <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="documentData.date = ''" :placeholder="$t('editEquipment.selectDate')" class="date-picker-custom"
                                :teleport="'body'" :disabled="!allowUpdateDocEquipment"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label for="modal-expiry-date" class="state">{{ $t('editEquipment.expiryDateLabel') }}</label>
                            <date-picker v-model="documentData.expiry_date" :formatter="momentFormat"
                                :range-separator="' - '" @clear="documentData.expiry_date = ''" :placeholder="$t('editEquipment.selectDate')"
                                class="date-picker-custom" :teleport="'body'"
                                :disabled="!allowUpdateDocEquipment"></date-picker>
                            <p v-if="errors && errors.expiry_date" class="field-error">
                                {{ errors.expiry_date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editEquipment.typeLabel') }}</label>
                            <b-form-select class="f-12" :options="getDotOptions" :disabled="!allowUpdateDocEquipment"
                                v-model="documentData.doc_type" @change="setDocDescription($event)">
                            </b-form-select>
                            <p v-if="errors && errors.doc_type" class="field-error">
                                {{ errors.doc_type[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editEquipment.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" :disabled="!allowUpdateDocEquipment"
                                :placeholder="$t('editEquipment.descriptionPlaceholder')" rows="3"
                                v-model="documentData.description"></b-form-textarea>
                            <p v-if="errors && errors.description" class="field-error pb-4">
                                {{ errors.description[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editEquipment.docDriverLabel') }}</label>
                            <b-form-checkbox :disabled="!allowUpdateDocEquipment" v-model="documentData.driver"
                                name="check-button" switch size="lg" class="ml-0-6rem" />
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editEquipment.dotModeLabel') }}</label>
                            <b-form-checkbox :disabled="!allowUpdateDocEquipment" v-model="documentData.dot_mode"
                                name="check-button" switch size="lg" class="ml-0-6rem" />
                        </div>
                        <div class="text-left">
                            <label class="state">{{ $t('editEquipment.publicLabel') }}</label>
                            <b-form-checkbox :disabled="!allowUpdateDocEquipment" v-model="documentData.public"
                                name="check-button" switch size="lg" class="ml-0-6rem" />
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12">
                        <div class="upload-btn-wrapper" v-if="!fileName">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!fileName" class="foo">
                                {{ $t('editEquipment.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>

                            <input ref="docFile" type="file" name="docFile" v-on:change="handleFileUpload"
                                accept=".pdf, .png, .jpg, .jpeg" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                        <div v-else>
                            <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                                <div v-else>
                                    <div id="panzoom-element" ref="panzoomElement">
                                        <img :src="media" class="w-100 h-100 img-section" />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center zoom-section">
                                        <b-icon @click="zoom(1)" icon="zoom-in"
                                            style="fill:white; cursor: pointer;"></b-icon>
                                        <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                            style="fill:white;cursor: pointer;"></b-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mt-4">
                    <b-button class="mx-0 h-40px w-100px m-0" @click="$bvModal.hide('modal-document'); panzoom = null"
                        variant="secondary" :class="hasDocChanged && allowUpdateDocEquipment ? 'mr-3' : ''">{{ editDocumentFlag ? $t('editEquipment.close') : $t('editEquipment.cancel') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendDocumentData"
                        v-if="hasDocChanged && allowUpdateDocEquipment">{{ $t('editEquipment.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <DeleteModal :message="assignedDriverMessage" :updateMessage="true" :removeMessage="''" v-if="assignedDriverMessage"
            @confirm="verifyDriverStatus" />
    </div>
</template>
<script>
import vSelect from "vue-select";
import AddTags from "@/components/Equipment/AddTags.vue";
import { mapActions, mapGetters } from "vuex";
import "vue-select/dist/vue-select.css";
import generateQRCode from "../../services/generateEquipmentQRCode";
import DeleteModal from "@/components/DeleteModal.vue";
import * as moment from "moment-timezone";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import ActivityLogs from "@/components/Shared/ActivityLogs.vue"
import { checkValueExists, checkDescriptionLength } from "../../services/helper";
import Panzoom from '@panzoom/panzoom'
import Notes from "../Shared/Notes";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
const numberMask = createNumberMask({
    prefix: "",
    allowDecimal: true,
    includeThousandsSeparator: true,
});
export default {
    data() {
        return {
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            numberMask,
            showTagsModal: false,
            checkValueExists,
            checkDescriptionLength,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            activeTab: "info",
            existingTags: [],
            equipmentCustomFields: [],
            customFieldValues: {},
            defaultCustomFieldValues: {},
            equipmentStatus: false,
            qrCodeUrl: "",
            showDeleteEquipmetModal: false,
            media: null,
            mediaType: null,
            panzoom: null,
            mediaID: null,
            emptyTable: false,
            itemId: null,
            showDocumentModal: false,
            showArchiveDocumentModal: false,
            requiredDocsRecords: [],
            unarchiveDocument: false,
            assignedDriverMessage: "",
            assignedDriver: false,
            showEquipmentModal: false,
            fileName: "",
            num_docs: 0,
            fields: [
                {
                    key: "Description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "expiry_date",
                    label: "Expiry Date",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Driver",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            currentPage: 1,
            items: [],
            defaultData: {},
            defaultDocsData: {},
            editDocumentFlag: false,
            docName: "",
            drivers: [],
            equipmentDriver: null,
            documentData: {
                object_id: null,
                date: null,
                type: null,
                expiry_date: "",
                document: null,
                description: null,
                driver: true,
                public: false,
                dot_mode: true,
                doc_type: ""
            },
            errors: {
                date: null,
                type: null,
                document: null,
                description: null,
            },
        }
    },
    name: "Edit-Equipment",
    components: {
        vSelect,
        AddTags,
        DeleteModal,
        ActivityLogs,
        Notes,
        DatePicker
    },
    props: ["equipmentID", "states", "options", "setNotesSection"],
    computed: {
        ...mapGetters([
            "currentEquipment",
            "company",
            "userCompany",
            "tags",
            "docTypeItems",
            "defaultDocType",
            "rolePermissions",
            "divisions"
        ]),
        requiredDocsMessage() {
            const docTypes = [...new Set(
                this.requiredDocsRecords
                    .flatMap((record) => record.missing_doc_type_ids || [])
                    .map((id) => this.docTypeItems.find((item) => item.id === id)?.type)
                    .filter(Boolean)
            )];
            return docTypes.length
                ? this.$t('editEquipment.requiredDocsMissing', { docs: docTypes.join(', ') })
                : this.$t('editEquipment.requiredDocsMissingCount', { count: this.requiredDocsRecords.length });
        },
        docSections() {
            if (!this.items.length) return []
            return [
                { key: 'all', title: '', docs: this.items.filter((item) => !item.is_archived) },
                {
                    key: 'archived',
                    title: this.$t('editEquipment.archivedDocsHeading'),
                    docs: this.items.filter((item) => item.is_archived)
                }
            ].filter((section) => section.docs.length)
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
        getEnterpriseStatus() {
            return (this.company[0]?.subscription?.type === 'Enterprise' && this.company[0]?.subscription?.status === 'active')
        },
        showActivitySection() {
            return this.rolePermissions && this.rolePermissions['Activity Log'] && this.rolePermissions['Activity Log'][0].allow
        },
        allowUpdateEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][1].allow
        },
        allowDeleteEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][3].allow
        },
        allowViewDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][6].allow
        },
        allowCreateDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][8].allow
        },
        allowUpdateDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][7].allow
        },
        allowDeleteDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][9].allow
        },
        hasChanged() {
            return JSON.stringify(this.customFieldValues) !== JSON.stringify(this.defaultCustomFieldValues) || this.assignedDriver || this.existingTags.toString() !== this.currentEquipment?.tags_obj?.map((tag) => tag.id).toString() || Object.keys(this.currentEquipment).filter(field => {
                if (field !== 'docs' && field !== 'num_docs' && field !== 'updated_at' && field !== 'company') {
                    if (typeof this.currentEquipment[field] === 'object') return JSON.stringify(this.currentEquipment[field]) !== JSON.stringify(this.defaultData[field])
                    if (field === 'current_odometer') return this.checkValueExists(this.currentEquipment[field])?.toString()?.replaceAll(",", "") != this.checkValueExists(this.defaultData[field])?.toString()?.replaceAll(",", "")
                    else if (!this.currentEquipment[field] && !this.defaultData[field]) return false
                    else return this.checkValueExists(this.currentEquipment[field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        },
        hasDocChanged() {
            return Object.keys(this.documentData).filter(field => {
                if (field !== 'updated_at') {
                    if (typeof this.documentData[field] === 'object') return JSON.stringify(this.documentData[field]) !== JSON.stringify(this.defaultDocsData[field])
                    if (field === 'description') {
                        return this.checkValueExists(this.documentData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultDocsData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n'));
                    }
                    else if (!this.documentData[field] && !this.defaultDocsData[field]) return false
                    else return this.checkValueExists(this.documentData[field]) != this.checkValueExists(this.defaultDocsData[field])
                } return false
            }).length > 0
        },
        getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model === this.currentEquipment?.type || item.model === 'All').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        }
    },
    watch: {
        currentEquipment() {
            this.existingTags = this.currentEquipment.tags_obj.map((item) => item.id);
            this.applyCustomFieldValues();
        },

        equipmentID: {
            async handler() {
                if (this.equipmentID) {
                    this.assignedDriver = false
                    this.drivers = []
                    this.equipmentDriver = null
                    this.requiredDocsRecords = []
                    this.activeTab = 'info'
                    try {
                        this.setLoader(true)
                        await this.getAllTags(this.userCompany);
                        await this.loadEquipmentCustomFields();
                        await this.getEquipment(this.equipmentID);
                        await this.loadRequiredDocs();
                        if (this.currentEquipment.active_date) {
                            this.currentEquipment.active_date = moment.tz(this.currentEquipment.active_date, this.userTimeZone).toDate();
                        }
                        if (this.currentEquipment.inactivate_date) {
                            this.currentEquipment.inactivate_date = moment.tz(this.currentEquipment.inactivate_date, this.userTimeZone).toDate();
                        }
                        if (this.currentEquipment.driver) {
                            this.drivers.push({
                                id: this.currentEquipment.driver.id,
                                label: this.currentEquipment.driver['first_name'] + ' ' + this.currentEquipment.driver['last_name'] + ' ' + '| ' + this.currentEquipment.driver['division_name'],
                            });
                            this.equipmentDriver = this.currentEquipment.driver.id
                        }
                        this.equipmentStatus = this.currentEquipment.status === "Active";
                        if (this.setNotesSection) {
                            if (this.allowViewDocEquipment) {
                                this.activeTab = 2
                            }
                            else this.activeTab = 1
                        }
                        this.defaultData = JSON.parse(JSON.stringify(this.currentEquipment))
                        this.updateDocs();
                        await this.$nextTick();
                        if (this.allowUpdateEquipment) {
                            this.qrCodeUrl =
                                this.$refs?.qrcode.qrious._canvasRenderer.element.toDataURL();
                        }
                        this.setLoader(false)
                    }
                    catch (e) {
                        this.setLoader(false)
                        console.log(e)
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions([
            "getEquipment",
            "getAllTags",
            "sendEquipmentDocument",
            "updateEquipmentDocument",
            "deleteEquipmentDocument",
            "updateEquipment",
            "setNotification",
            "deleteEquipment",
            "setLoader",
            "retrieveDocument",
            "updateEquipmentStatus",
            "getFilteredDrivers",
            "getDriversAssignmentStatus",
            "updateTeamMember",
            "getCustomFields",
            "getAllRequiredDocs"
        ]),
        async loadRequiredDocs() {
            try {
                if (!this.currentEquipment.unit_no) return;
                const url = `page=1&page_size=25&equipment_id=${this.currentEquipment.id}&required=True`;
                const requiredDocs = await this.getAllRequiredDocs(url);
                this.requiredDocsRecords = requiredDocs?.records || [];
            } catch (e) {
                console.log(e);
            }
        },
        async loadEquipmentCustomFields() {
            try {
                const model = (this.$route.name || '').toLowerCase();
                if (model !== 'vehicle' && model !== 'trailer') return;
                const list = await this.getCustomFields(model);
                this.equipmentCustomFields = (list || [])
                    .filter(f => f.model === model)
                    .slice()
                    .sort((a, b) => (a.order || 0) - (b.order || 0));
                this.applyCustomFieldValues();
            } catch (e) {
                console.log(e);
            }
        },
        applyCustomFieldValues() {
            const existing = (this.currentEquipment && Array.isArray(this.currentEquipment.custom_fields))
                ? this.currentEquipment.custom_fields
                : [];
            const lookup = {};
            existing.forEach(entry => {
                const id = entry.id || entry.custom_field;
                if (id != null) lookup[id] = entry.value;
            });
            const next = {};
            this.equipmentCustomFields.forEach(f => {
                if (Object.prototype.hasOwnProperty.call(lookup, f.id)) {
                    next[f.id] = lookup[f.id];
                } else {
                    next[f.id] = f.field_type === 'multi_select' ? [] : null;
                }
            });
            this.customFieldValues = next;
            this.defaultCustomFieldValues = JSON.parse(JSON.stringify(next));
        },
        buildCustomFieldsWrite() {
            return this.equipmentCustomFields.map(f => {
                let v = this.customFieldValues[f.id];
                if (v === undefined || v === null) {
                    v = f.field_type === 'multi_select' ? [] : null;
                }
                return { id: f.id, value: v };
            });
        },
        getDriverLabel() {
            return this.drivers.find((item) => item.id === this.equipmentDriver)?.label
        },
        verifyDriverStatus(status) {
            this.assignedDriverMessage = ""
            if (!status) {
                this.assignedDriver = false
                this.equipmentDriver = null
            }
        },
        getDriverData(e) {
            const driverData = this.drivers.find((item) => item.id === e)
            if (driverData && driverData?.label) {
                const assignedEquipment = this.currentEquipment.type === 'Trailer'
                    ? driverData?.defaultTrailer
                    : driverData?.defaultVehicle
                this.assignedDriverMessage = `<h3 class="f-18 mb-3">${this.$t('editEquipment.assignDriverConfirm', { driver: driverData?.label, unit: this.currentEquipment.unit_no })}</h3>`
                if (assignedEquipment?.equipment_unit_no && assignedEquipment.equipment_id !== this.currentEquipment.id) {
                    this.assignedDriverMessage += `<span class="d-block text-grey f-14 fw-400 mb-0">${this.$t('editEquipment.driverAlreadyAssigned', { units: assignedEquipment.equipment_unit_no })}</span>`
                }
                this.assignedDriver = true
            }
        },
        async goToDriverDetail(id, label) {
            try {
                await this.updateEquipmentData(false);
                const driverLabel = label.split(' | ')[0].trim();
                this.$router.push(`/drivers?id=${id}&driver=${driverLabel}`);
            } catch (e) {
                console.log(e)
            }
        },
        async searchDriver(searchText) {
            if (searchText) {
                const driverRecords = await this.getDriversAssignmentStatus(searchText);
                this.drivers = []
                driverRecords
                    .map((item) => {
                        this.drivers.push({
                            id: item.driver_id,
                            label: `${item.driver_name} | ${item.driver_division_name}`,
                            defaultVehicle: item.default_vehicle,
                            defaultTrailer: item.default_trailer
                        });
                    });
            }
        },
        archiveDocumentItem(status) {
            if (status) {
                this.archiveDocument();
            }
            this.showArchiveDocumentModal = false;
        },
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        setDocDescription(event) {
            if (event) {
                this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
            }
            else this.documentData.description = this.defaultDocsData.description
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });
            return formattedText;
        },
        changeEquipmentStatusItem(item) {
            if (item) {
                this.changeEquipmentStatus()
            }
            this.showEquipmentModal = false
        },
        async changeEquipmentStatus() {
            try {
                this.setLoader(true)
                await this.updateEquipmentStatus({
                    action: this.currentEquipment.status === 'Assigned' || this.currentEquipment.status === 'Active' ? 'deactivate' : 'activate',
                    equipment_ids: [this.currentEquipment.id]
                })
                await this.setNotification({
                    msg: (this.currentEquipment.status === 'Assigned' || this.currentEquipment.status === 'Active') ? this.$t('editEquipment.equipmentDeactivated') : this.$t('editEquipment.equipmentActivated'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
                this.$emit("updateData", true);
                this.$emit("resetEquipment", true);
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        showPopup(id) {
            this.showDocumentModal = true;
            this.itemId = id;
        },
        showArchivePopup(id, isArchived = false) {
            this.showArchiveDocumentModal = true
            this.unarchiveDocument = isArchived;
            this.itemId = id;
        },
        async archiveDocument() {
            try {
                const data = this.items.filter(
                    (item) => this.itemId === item.pk
                )[0];
                await this.updateEquipmentDocument({
                    id: data.pk,
                    payload: { ...data, is_archived: !this.unarchiveDocument, date: moment(data.date).format("YYYY-MM-DD"), expiry_date: data.expiry ? moment(data.expiry).format("YYYY-MM-DD") : null, object_id: this.currentEquipment.id },
                });
                await this.setNotification({
                    msg: this.unarchiveDocument ? this.$t('editEquipment.docUnarchived') : this.$t('editEquipment.docArchived'),
                    type: "success",
                    color: "green",
                });
                await this.getEquipment(this.equipmentID);
                this.updateDocs();
                this.$emit("updateData", true);
            } catch (error) {
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async editDocument(id, docID) {
            this.editDocumentFlag = true;
            this.documentIndex = id;
            this.documentData = { ...this.currentEquipment.docs[id], doc_type: this.currentEquipment.docs[id].doc_type_id, date: moment.tz(this.currentEquipment.docs[id].date, this.userTimeZone).toDate(), expiry_date: this.currentEquipment.docs[id].expiry_date ? moment.tz(this.currentEquipment.docs[id].expiry_date, this.userTimeZone).toDate() : "" };
            if (this.documentData.document) {
                let file_name = "";
                if (typeof this.documentData.document === "string") {
                    file_name = this.documentData.document;
                } else {
                    file_name = this.documentData.document.name;
                }
                this.fileName = file_name.substring(file_name.lastIndexOf("/") + 1);
            }
            this.errors = {
                date: null,
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                ...this.company[0].doc_type ? { doc_type: null } : {}
            };
            await this.openDoc(docID)
            this.defaultDocsData = JSON.parse(JSON.stringify({ ...this.documentData, doc_type: this.currentEquipment.docs[id].doc_type_id ? this.currentEquipment.docs[id].doc_type_id : '' }))
            this.$bvModal.show("modal-document");
        },
        async downloadDoc(id, name) {
            this.setLoader(true)
            const doc = await this.retrieveDocument(id);
            fetch(doc.document)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const newUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    const urlWithoutParams = doc.document.split('?')[0];
                    const extension = urlWithoutParams.split('.').pop();
                    a.download = name + "." + extension
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                })
                .catch(error => {
                    this.setLoader(false)
                    console.log(error)
                });
        },
        async openDoc(id) {
            const doc = await this.retrieveDocument(id);
            this.media = doc.document
            this.mediaID = id
            this.itemId = id;
            if (doc.document.includes('.pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        async deleteDocumentItem(item) {
            if (item) {
                await this.deleteDocument(this.itemId);
            }
            this.showDocumentModal = false;
        },
        async deleteDocument(id) {
            try {
                this.setLoader(true)
                await this.deleteEquipmentDocument(`${id}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: this.$t('editEquipment.docDeleted'),
                    type: "success",
                    color: "green",
                });
                await this.getEquipment(this.equipmentID);
                this.updateDocs();
                this.defaultData = JSON.parse(JSON.stringify(this.currentEquipment))
                this.$bvModal.hide("modal-document");
                this.setLoader(false)
                this.$emit("updateData", true);
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        updateDocs() {
            this.items = [];
            this.currentEquipment.docs.sort((a, b) => a.description.toLowerCase().localeCompare(b.description.toLowerCase())).forEach((doc, id) => {
                let color;
                if (doc.expiry_date) {
                    const currentDate = new Date();
                    const expiryDate = new Date(doc.expiry_date);
                    const diffDays = parseInt(
                        (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                        10
                    );
                    if (diffDays > 30) {
                        color = "color:black";
                    } else if (diffDays <= 30 && diffDays >= 1) {
                        color = "color:#FFC800";
                    } else color = "color:#FF0000";
                }
                this.items.push({
                    id: id,
                    pk: doc.id,
                    Date: moment(doc.date).format("ll"),
                    Description: doc.description,
                    expiry_date: doc.expiry_date
                        ? `<span style=${color}>${moment(doc.expiry_date).format(
                            "LL"
                        )}</span>`
                        : "-",
                    Public: doc.public,
                    dot_mode: doc.dot_mode,
                    Driver: doc.driver,
                    link: doc.document,
                    name: `${this.currentEquipment.unit_no}-${doc.description ? doc.description : ''}`,
                    expiry: doc.expiry_date,
                    is_archived: doc.is_archived
                });
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
            });
        },
        removeFile() {
            this.fileName = null;
            // this.$refs.docFile.value = "";
            this.documentData.document = null
            this.media = null
            this.mediaType = null
        },
        async updateDocumentOnToggle(id, key, value) {
            try {
                this.setLoader(true)
                this.currentEquipment.docs[id][key] = value;
                if (!this.currentEquipment.docs[id].expiry_date)
                    delete this.currentEquipment.docs[id].expiry_date;
                delete this.currentEquipment.docs[id].document;
                await this.updateEquipmentDocument({
                    id: this.currentEquipment.docs[id].id,
                    payload: this.currentEquipment.docs[id],
                });
                await this.setNotification({
                    msg: this.$t('editEquipment.docUpdated'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        extractFilePath(url) {
            const pathname = new URL(url).pathname;

            return pathname.substring(pathname.indexOf("documents/"));
        },
        async sendDocumentData() {
            try {
                if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
                    throw {
                        description: [this.$t('editEquipment.descriptionMaxLength')],
                    };
                }
                const nullKeys = this.checkNullValues({
                    date: this.documentData.date,
                    document: this.documentData.document,
                    ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    let formData = new FormData();
                    let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
                    if (!fileType) this.documentData.document = null
                    formData.append("object_id", this.currentEquipment.id);
                    formData.append(
                        "date",
                        moment(this.documentData.date).format("YYYY-MM-DD")
                    );
                    formData.append("type", this.documentData.type);
                    formData.append("description", this.documentData.description);
                    if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
                    formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
                    if (this.documentData.document) {
                        formData.append(
                            "document",
                            new File(
                                [this.documentData.document],
                                this.currentEquipment.unit_no + "_" + this.documentData.description +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.documentData.document["type"].split("/").pop(),
                                { type: this.documentData.document["type"] }
                            )
                        );
                    }
                    formData.append("driver", this.documentData.driver);
                    formData.append("public", this.documentData.public);
                    formData.append("dot_mode", this.documentData.dot_mode);
                    formData.append("model_type", "equipment");
                    formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                    if (this.currentEquipment.current_odometer) {
                        formData.append("current_odometer", this.currentEquipment.current_odometer.toString().replace(/,/g, ""))
                    }
                    if (this.editDocumentFlag) {
                        this.documentData = await this.updateEquipmentDocument({
                            id: this.documentData.id,
                            payload: formData
                        });
                        this.editDocumentFlag = false;
                        await this.setNotification({
                            msg: this.$t('editEquipment.docUpdated'),
                            type: "success",
                            color: "green",
                        });
                        let color;
                        if (this.documentData.expiry_date) {
                            const currentDate = new Date();
                            const expiryDate = new Date(this.documentData.expiry_date);
                            const diffDays = parseInt(
                                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                                10
                            );
                            if (diffDays > 30) {
                                color = "color:black";
                            } else if (diffDays <= 30 && diffDays >= 1) {
                                color = "color:#FFC800";
                            } else color = "color:#FF0000";
                        }
                        this.currentEquipment.docs[this.documentIndex] = { ...this.documentData, doc_type_id: this.documentData.doc_type, document: this.extractFilePath(this.documentData.document) };
                        this.items[this.documentIndex].Date = moment(
                            this.documentData.date
                        ).format("ll");
                        this.items[this.documentIndex].Type = this.documentData.type;
                        this.items[this.documentIndex].Description =
                            this.documentData.description;
                        this.items[this.documentIndex].expiry_date = this.documentData
                            .expiry_date
                            ? `<span style=${color}>${moment(
                                this.documentData.expiry_date
                            ).format("ll")}</span`
                            : "-";
                        this.items[this.documentIndex] = this.documentData.driver;
                        this.editDocumentFlag = false;
                        this.$bvModal.hide("modal-document");
                        this.documentData = {
                            object_id: null,
                            date: null,
                            type: null,
                            document: null,
                            description: null,
                            expiry_date: "",
                            driver: true,
                            public: false,
                            dot_mode: true,
                            doc_type: ""
                        };
                        this.$emit("updateData")
                        this.updateDocs();
                    } else {
                        if (this.documentData.date) {

                            const docs = await this.sendEquipmentDocument(formData);
                            if (docs) {
                                await this.getEquipment(this.equipmentID);
                                this.defaultData = JSON.parse(JSON.stringify(this.currentEquipment))
                                this.updateDocs();
                                await this.setNotification({
                                    msg: this.$t('editEquipment.docAdded'),
                                    type: "success",
                                    color: "green",
                                });
                            }
                            await this.getEquipment(this.equipmentID);
                            this.defaultData = JSON.parse(JSON.stringify(this.currentEquipment))
                            this.$bvModal.hide("modal-document");
                            this.$emit("updateData", true);
                            this.documentData = {
                                object_id: null,
                                date: null,
                                type: null,
                                document: null,
                                description: null,
                                expiry_date: "",
                                driver: true,
                                public: false,
                                dot_mode: true,
                                doc_type: ""
                            };
                        } else {
                            this.errors.date = this.documentData.date
                                ? null
                                : [this.$t('editEquipment.fieldRequired')];
                        }
                    }
                    this.setLoader(false);
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('editEquipment.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        addDocument() {
            this.fileName = null;
            this.editDocumentFlag = false;
            this.$bvModal.show("modal-document");
            this.documentData = {
                object_id: null,
                date: new Date(),
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                driver: true,
                public: false,
                dot_mode: true,
                doc_type: ""
            };
            this.defaultDocsData = JSON.parse(JSON.stringify(this.documentData))
            this.errors = {
                date: null,
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                ...this.company[0].doc_type ? { doc_type: null } : {}
            };
        },
        closePopup() {
            this.$emit("resetEquipment", true);
        },
        async deleteEquipmentItem(item) {
            if (item) {
                await this.deleteTeamEquipment(this.itemId);
            }
            this.showDeleteEquipmetModal = false;
        },
        async deleteTeamEquipment() {
            try {
                this.setLoader(true)
                await this.deleteEquipment(`${this.equipmentID}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: this.$t('editEquipment.equipmentDeleted', { type: this.currentEquipment.type }),
                    type: "success",
                    color: "green",
                });
                this.$emit("updateData", true);
                this.$emit("resetEquipment", true);
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        changeEquipmentStatusField() {
            this.currentEquipment.status = this.equipmentStatus
                ? "Active"
                : "Inactive";
        },
        handleFileUpload() {
            this.documentData.document = this.$refs.docFile.files[0];
            this.fileName = this.documentData.document.name;
            this.media = URL.createObjectURL(this.documentData.document);
            if (this.$refs.docFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        generateEquipmentQRCode(unitNo, fileName, qrCode) {
            generateQRCode(unitNo, fileName, qrCode)
        },
        async removeTag(tag) {
            const index = this.existingTags.indexOf(tag);
            this.existingTags.splice(index, 1);
            await this.updateEquipmentData(false);
        },
        addTag() {
            this.showTagsModal = false;
        },
        resetField() {
            if (this.$refs.docFile) this.$refs.docFile.value = null;
        },
        async updateEquipmentData(closePopup = true) {
            try {
                const nullKeys = this.checkNullValues({
                    unit_no: this.currentEquipment.unit_no,
                    ...this.company[0].is_division_required ? { division: this.currentEquipment.division } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    Object.keys(this.currentEquipment).forEach((e) => {
                        if (this.currentEquipment[e] === "") {
                            this.currentEquipment[e] = null;
                        }
                    });
                    delete this.currentEquipment.picture;
                    delete this.currentEquipment.company;
                    delete this.currentEquipment.country;
                    let equipmentData = {
                        ...this.currentEquipment,
                        type: this.$route.name,
                        state: this.currentEquipment.state.id
                            ? this.currentEquipment.state.id
                            : 54,
                        plate_no: this.currentEquipment.plate_no
                            ? this.currentEquipment.plate_no.toUpperCase()
                            : null,
                        vin_no: this.currentEquipment.vin_no
                            ? this.currentEquipment.vin_no.toUpperCase()
                            : null,
                        dispatch_group1: this.dispatch_group1,
                        dispatch_group2: this.dispatch_group2,
                        division: this.currentEquipment.division,
                        ...this.currentEquipment.current_odometer ? { current_odometer: this.currentEquipment.current_odometer.toString().replace(/,/g, "") } : {},
                        active_date: this.currentEquipment.active_date ? moment(this.currentEquipment.active_date).format("YYYY-MM-DD") : null,
                        inactivate_date: this.currentEquipment.inactivate_date ? moment(this.currentEquipment.inactivate_date).format("YYYY-MM-DD") : null,
                        status: this.assignedDriver ? 'Assigned' : this.currentEquipment.status,
                    };
                    if (this.assignedDriver) {
                        await this.updateTeamMember({
                            id: this.equipmentDriver,
                            payload: this.currentEquipment.type === 'Vehicle' ? { default_vehicle: this.currentEquipment.id } : { default_trailer: this.currentEquipment.id },
                            companyID: this.userCompany
                        });
                    }
                    const updatedEquipment = await this.updateEquipment({
                        id: this.equipmentID,
                        payload: {
                            ...equipmentData,
                            tags: this.existingTags,
                            custom_fields_write: this.buildCustomFieldsWrite(),
                        },
                    });
                    if (this.currentEquipment) {
                        await this.setNotification({
                            msg: this.$t('editEquipment.equipmentUpdated', { unit: this.currentEquipment.unit_no }),
                            type: "success",
                            color: "green",
                        });
                        if (closePopup) {
                            this.$emit("updateEquipment", updatedEquipment);
                            this.$emit("resetEquipment", true);
                        }
                        else this.$emit("updateData", true);
                    }
                    this.setLoader(false)
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('editEquipment.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                } else {
                    await this.setNotification({
                        msg: error,
                        type: "error",
                        color: "red",
                    });
                }
            }
        },
    },
}
</script>
<style>
.equipment-edit-modal .body {
    padding: 0px 25px 25px 25px !important;
}

.required-docs-banner {
    background-color: #FDE8E8;
    border: 1px solid #F5C2C2;
    border-radius: 8px;
    padding: 10px 14px;
    color: #B91C1C;
}

.equipment-edit-modal .equipment-tabs {
    position: sticky;
    top: 0;
    z-index: 999;
}

.equipment-edit-modal.modal-body {
    padding: 0px !important
}

.sidebar-footer {
    border-top: 1px solid #EAEAEA;
    padding: 1rem 1.4rem;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: white;
}

.sidebar-tabs {
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    background-color: white;
}

.mt-4rem {
    margin-top: 4rem;
}

.mt-3rem {
    margin-top: 3rem;
}

.edit-equipment-status {
    width: 88px !important;
    height: 30px !important;
}

.remove-doc {
    top: 10px;
    z-index: 1;
    right: 15px
}

@media (max-width: 425px) {
    .sidebar-b-margin {
        margin-bottom: 9rem;
    }
}
</style>